import type { Environment } from '@/lib/api'

/**
 * The global environment filter's default. The selection itself lives in
 * the URL with the other global filters (`lib/filters.ts`).
 *
 * The empty selection *is* the production default: the app sends no environment
 * parameter and the server applies production. Keeping the default implicit
 * rather than pre-selecting 'production' means there is exactly one place in the
 * system that decides what a default view contains, and it is the server.
 */
export const PRODUCTION_ONLY: readonly Environment[] = []

export function isNonProduction(environments: readonly Environment[]): boolean {
  return environments.some((environment) => environment !== 'production')
}

/** The one place an `Environment` value becomes the label a person reads. */
export const ENVIRONMENT_LABELS: Record<Environment, string> = {
  production: 'Production',
  staging: 'Staging',
  test: 'Test',
  development: 'Development',
}
